import {OperatorService, OPERATOR_SERVICE_NAME} from "../service/admin/OperatorService";
import {UserAuditService, UserAuditServiceImpl, USER_AUDIT_SERVICE_NAME} from "../service/admin/UserAuditService";
import {kernel} from "./IOCHelper";
import {HttpService, HTTP_SERVICE_NAME, HttpServiceImpl} from "../service/http/HttpService";
import {AppProperties, APP_PROPERTIES_NAME, AppPropertiesImpl} from "../AppProperties";
import {
    ScheduledTournamentService,
    SCHEDULED_TOURNAMENT_SERVICE_NAME,
    ScheduledTournamentServiceImpl
} from "../service/poker/tournament/ScheduledTournamentService";
import {
    TournamentConstraintsService,
    TOURNAMENT_CONSTRAINTS_SERVICE_NAME,
    TournamentConstraintsServiceImpl
} from "../service/poker/tournament/TournamentConstraintsService";
import {
    DashboardUserService,
    DASHBOARD_USER_SERVICE_NAME,
    DashboardUserServiceImpl
} from "../service/DashboardUserService";
import {MenuService, MENU_SERVICE_NAME, MenuServiceImpl} from "../service/MenuService";
import {UserService, USER_SERVICE_NAME, UserServiceImpl} from "../service/admin/UserService";
import {UserGroupServiceImpl, UserGroupService, USER_GROUP_SERVICE_NAME} from "../service/admin/UserGroupService";
import {
    WalletService,
    WALLET_SERVICE_NAME,
    WalletServiceImpl,
} from "../service/admin/WalletService";
import {UserActionsImpl, UserActions} from "../actions/UserActions";
import {
    LeaderboardService,
    LEADERBOARD_SERVICE_NAME,
    LeaderboardServiceImpl
} from "../service/poker/leaderboard/LeaderboardService";
import {
    LeaderboardCounterService,
    LeaderboardCounterServiceImpl,
    LEADERBOARD_COUNTER_SERVICE_NAME
} from "../service/poker/leaderboard/LeaderboardCounterService";
import {BonusService, BONUS_SERVICE_NAME, BonusServiceImpl} from "../service/bonus/BonusService";
import {
    OperatorProgressionService,
    OPERATOR_PROGRESSION_SERVICE_NAME,
    OperatorProgressionServiceImpl
} from "../service/operator/OperatorProgressionService";
import {ITEM_SERVICE_NAME, ItemService, ItemServiceImpl} from "../service/admin/ItemService";
import {altInstance, AppCtx} from "./ApplicationContext";
import {Symbols} from "./Symbols";
import {UserStore} from "../store/UserStore";
import {AchievementsService, AchievementsServiceImpl} from "../service/achievements/AchievementsService";
import {SystemEventServiceImpl, SystemEventService} from "../service/admin/SystemEventService";
import {HandHistoryService, HandHistoryServiceImpl} from "../service/poker/history/HandHistoryService";
import {TournamentHistoryService, TournamentHistoryServiceIml} from "../service/poker/history/TournamentHistoryService";
import {SitAndGoService, SitAndGoServiceImpl} from "../service/poker/tournament/SitAndGoService";
import {BlindsStructureService, BlindsStructureServiceImpl} from "../service/poker/tournament/BlindsStructureService";
import {PayoutStructureService, PayoutStructureServiceImpl} from "../service/poker/tournament/PayoutStructureService";
import {ProductService, ProductServiceImpl} from "../service/admin/ProductService";
import {
    ITEM_PLAYERS_SERVICE_NAME,
    ItemPlayersService,
    ItemPlayersServiceImpl
} from "../service/admin/ItemPlayersService";
import {
    ITEM_HISTORY_SERVICE_NAME,
    ItemHistoryService,
    ItemHistoryServiceImpl
} from "../service/admin/ItemHistoryService";
import {MASS_UPDATE_SERVICE_NAME, MassUpdateService, MassUpdateServiceImp} from "../service/admin/MassUpdateService";
import {
    BlackjackHandHistoryService,
    BlackjackHandHistoryServiceImpl
} from "../service/blackjack/history/BlackjackHandHistoryService";
import {
    CaribbeanPokerHandHistoryService,
    CaribbeanPokerHandHistoryServiceImpl
} from '../service/caribbean-poker/history/CaribbeanPokerHandHistoryService'
import {NotificationService, NotificationServiceImpl} from "../service/admin/NotificationService";
import {SlotSpinHistoryService, SlotSpinHistoryServiceImpl} from "../service/slots/history/SlotSpinHistoryService";
import {TransactionHistoryService} from "../service/admin/TransactionHistoryService";
import {
    CasinoHoldemHandHistoryService,
    CasinoHoldemHandHistoryServiceImpl
} from "../service/casino-holdem/history/CasinoHoldemHandHistoryService";


export function wire() {

    kernel.bind<HttpService>(HTTP_SERVICE_NAME).to(HttpServiceImpl).inSingletonScope();
    kernel.bind<DashboardUserService>(DASHBOARD_USER_SERVICE_NAME).to(DashboardUserServiceImpl).inSingletonScope();

    let userActions = altInstance.createActions<UserActions>(UserActionsImpl);
    kernel.bind<UserActions>(Symbols.UserActions).toConstantValue(userActions);

    let userStore = AppCtx.getAlt().createStore(UserStore, "UserStore");
    kernel.bind<AltJS.AltStore<UserStore>>(Symbols.UserStore).toConstantValue(userStore);

    kernel.bind<AppProperties>(APP_PROPERTIES_NAME).to(AppPropertiesImpl).inSingletonScope();
    kernel.bind<ScheduledTournamentService>(SCHEDULED_TOURNAMENT_SERVICE_NAME).to(ScheduledTournamentServiceImpl).inSingletonScope()
    kernel.bind<TournamentConstraintsService>(TOURNAMENT_CONSTRAINTS_SERVICE_NAME).to(TournamentConstraintsServiceImpl).inSingletonScope();

    kernel.bind<MenuService>(MENU_SERVICE_NAME).to(MenuServiceImpl).inSingletonScope();
    kernel.bind<UserService>(USER_SERVICE_NAME).to(UserServiceImpl).inSingletonScope();
    kernel.bind<UserAuditService>(USER_AUDIT_SERVICE_NAME).to(UserAuditServiceImpl).inSingletonScope();
    kernel.bind<WalletService>(WALLET_SERVICE_NAME).to(WalletServiceImpl).inSingletonScope();
    kernel.bind<MassUpdateService>(MASS_UPDATE_SERVICE_NAME).to(MassUpdateServiceImp).inSingletonScope();
    kernel.bind<UserGroupService>(USER_GROUP_SERVICE_NAME).to(UserGroupServiceImpl).inSingletonScope();
    kernel.bind<LeaderboardService>(LEADERBOARD_SERVICE_NAME).to(LeaderboardServiceImpl).inSingletonScope();
    kernel.bind<LeaderboardCounterService>(LEADERBOARD_COUNTER_SERVICE_NAME).to(LeaderboardCounterServiceImpl).inSingletonScope();
    kernel.bind<BonusService>(BONUS_SERVICE_NAME).to(BonusServiceImpl).inSingletonScope();
    kernel.bind<OperatorProgressionService>(OPERATOR_PROGRESSION_SERVICE_NAME).to(OperatorProgressionServiceImpl).inSingletonScope();
    kernel.bind<ItemService>(ITEM_SERVICE_NAME).to(ItemServiceImpl).inSingletonScope();
    kernel.bind<ItemPlayersService>(ITEM_PLAYERS_SERVICE_NAME).to(ItemPlayersServiceImpl).inSingletonScope();
    kernel.bind<ItemHistoryService>(ITEM_HISTORY_SERVICE_NAME).to(ItemHistoryServiceImpl).inSingletonScope();
    kernel.bind<OperatorService>(OPERATOR_SERVICE_NAME).to(OperatorService).inSingletonScope();
    kernel.bind<AchievementsService>(Symbols.AchievementsService).to(AchievementsServiceImpl).inSingletonScope();
    kernel.bind<SystemEventService>(Symbols.SystemEventService).to(SystemEventServiceImpl).inSingletonScope();
    kernel.bind<HandHistoryService>(Symbols.HandHistoryService).to(HandHistoryServiceImpl).inSingletonScope();
    kernel.bind<TournamentHistoryService>(Symbols.TournamentHistoryService).to(TournamentHistoryServiceIml).inSingletonScope();
    kernel.bind<SitAndGoService>(Symbols.SitAndGoService).to(SitAndGoServiceImpl).inSingletonScope();
    kernel.bind<BlindsStructureService>(Symbols.BlindsStructureService).to(BlindsStructureServiceImpl).inSingletonScope();
    kernel.bind<PayoutStructureService>(Symbols.PayoutStructureService).to(PayoutStructureServiceImpl).inSingletonScope();
    kernel.bind<ProductService>(Symbols.ProductService).to(ProductServiceImpl).inSingletonScope();
    kernel.bind<BlackjackHandHistoryService>(Symbols.BlackjackHandHistoryService).to(BlackjackHandHistoryServiceImpl).inSingletonScope();
    kernel.bind<CaribbeanPokerHandHistoryService>(Symbols.CaribbeanPokerHandHistoryService).to(CaribbeanPokerHandHistoryServiceImpl).inSingletonScope();
    kernel.bind<CasinoHoldemHandHistoryService>(Symbols.CasinoHoldemHandHistoryService).to(CasinoHoldemHandHistoryServiceImpl).inSingletonScope();
    kernel.bind<NotificationService>(Symbols.NotificationService).to(NotificationServiceImpl).inSingletonScope();
    kernel.bind<SlotSpinHistoryService>(Symbols.SlotSpinHistoryService).to(SlotSpinHistoryServiceImpl).inSingletonScope();
    kernel.bind<TransactionHistoryService>(Symbols.TransactionHistoryService).to(TransactionHistoryService).inTransientScope();
}



// WEBPACK FOOTER //
// ./src/app/ioc/ApplicationSetup.ts